/* eslint no-console: 'off' */

const levels = ['silly', 'debug', 'info', 'warn', 'error']

const level =
  (typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('logLevel')) ||
  import.meta.env.VITE_LOG_LEVEL

const silly = levels.indexOf(level) === 0
const debug = levels.indexOf(level) <= 1
const info = levels.indexOf(level) <= 2
const warn = levels.indexOf(level) <= 3
const error = !level || level === 'error'

const noLog = () => null

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const logger = ({ category }: { category: string }) => ({
  silly: silly ? console.debug : noLog,
  debug: debug ? console.debug : noLog,
  info: info ? console.log : noLog,
  warn: warn ? console.warn : noLog,
  error: error ? console.error : noLog,
})

export default logger
